import { api } from '@adaptcx/shared/services/api'

export type AssistMode = 'omni' | 'google_native'

export interface CcaiConfig {
  conversation_profile_id?: string
  knowledge_base_ids?: string[]
  model_id?: string
  notification_config?: Record<string, unknown>
  [key: string]: unknown
}

export interface AssistTenantConfig {
  id: string
  tenant_id: string
  assist_mode: AssistMode
  gcp_project_id: string | null
  assist_connector_enabled: boolean
  audiohook_enabled: boolean
  middleware_enabled: boolean
  context_mode: 'rag' | 'structured' | 'agent_ready' | 'minimal'
  classifier_threshold: number
  default_llm_provider: string | null
  default_llm_model: string | null
  default_system_prompt: string | null
  session_ttl_seconds: number
  max_transcript_history: number
  pubsub_topics_created: boolean
  ccai_profile_id: string | null
  ccai_config: CcaiConfig | null
  google_datastore_id: string | null
  ccai_profiles_enabled: boolean
  created_at: string
  updated_at: string
}

export interface AssistConfigUpdate {
  gcp_project_id?: string
  assist_connector_enabled?: boolean
  audiohook_enabled?: boolean
  middleware_enabled?: boolean
  context_mode?: string
  classifier_threshold?: number
  default_llm_provider?: string
  default_llm_model?: string
  default_system_prompt?: string
  session_ttl_seconds?: number
  max_transcript_history?: number
  ccai_profile_id?: string
  ccai_config?: CcaiConfig
  google_datastore_id?: string
  ccai_profiles_enabled?: boolean
}

export const assistConfigService = {
  async getConfig(): Promise<AssistTenantConfig> {
    const response = await api.get('/api/v1/assist/config')
    return response.data
  },

  async updateConfig(data: AssistConfigUpdate): Promise<AssistTenantConfig> {
    const response = await api.put('/api/v1/assist/config', data)
    return response.data
  },
}
